var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('employment-doc-view', _vm._b({
    ref: "employment-doc-view"
  }, 'employment-doc-view', {
    contract: _vm.form,
    value: _vm.fields,
    pages: _vm.pages,
    mode: _vm.mode
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }